import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { checkClient, clearCheck } from "../../redux/modules/check-client";
import InputField from "../common/input-field"
import { useForm } from "../../hooks/use-form";
import Layout from "../layout"

function CheckClient(props) {  
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const checkclient = useSelector(state => state.checkclient);

  const [fields, setValue, setFieldValid, formIsValid, trigger, setTrigger, setValidate, setCheckValue, setAddress, setInn, setValueSelect, clearForm] = useForm({
    phone: {
      value: '',
      name: 'phone',
      type: 'tel',
      placeholder: '+7 000 000 00 00',
      validate: 'phone',
      valid: false,
    }
  }, []);

  useEffect(() => {    
    document.title = 'Проверить клиента | Личный кабинет Брокера THE FIVE';

    let link = document.getElementById("check");
    link.addEventListener("click", clear);

    return () => {
      clear();
      link.removeEventListener('scroll', clear);
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (formIsValid()) {
        dispatch(
          checkClient({
            cmd: 'clients-check',
            phone: fields.phone.value.replace(/[^0-9]/g, ''),
            _debug_token: auth.token
          }
        ))
    } 
  };

  const clear = () => {
    clearForm();
    dispatch(clearCheck());
  }

  return (    
    <Layout>
      <div className="check-client">
        {!checkclient.checked && !checkclient.error && (
          <form className="form fadeIn" onSubmit={handleSubmit}>
            <div className="form__title">Проверить клиента</div>
            <div className="form__text">Введите номер телефона, чтобы проверить уникальность&nbsp;клиента </div>
            <InputField
                trigger={trigger}
                setFieldValid={setFieldValid}
                setValue={setValue}
                {...fields.phone}
            />
            <button type={'submit'} className="btn">Проверить</button>
          </form>
        )}
        {checkclient.checked && checkclient.check && ( 
          <div className="form fadeIn">
            <div className="form__title">Результат проверки</div>
            <div className="check-result check-result_success">Клиент уникальный</div>
            <div className="form__buttons">
              <Link to="/regist-meeting" state={{ phone: fields.phone.value }} className="btn">Записать на встречу</Link>
              <button type="button" className="btn btn_empty" onClick={clear}>Проверить другого клиента</button>
            </div>
          </div>
        )}
        {checkclient.checked && !checkclient.check && (
          <div className="form fadeIn">
            <div className="form__title">Результат проверки</div>
            <div className="check-result check-result_error">Клиент не уникальный</div>
            <div className="form__buttons">
              <button type="button" className="btn" onClick={clear}>Проверить другого клиента</button>
            </div>
          </div>
        )}
        {checkclient.error && ( 
          <div className="form fadeIn">
            <div className="form__title">Результат проверки</div>
            <div className="check-result check-result_error">{checkclient.error}</div>
            <div className="form__buttons">
              <button type="button" className="btn" onClick={clear}>Проверить ещё раз</button>
            </div>
          </div>
        )}
        {checkclient.loading && <div class="loader"><div class="loader__load"></div></div>}
      </div>    
    </Layout>
  );
}
export default CheckClient;